import * as React from "react";

import Container from '@mui/material/Container';
import CircularProgress from '@mui/material/CircularProgress';
import Box from '@mui/material/Box';

import KitchenOrderCard from '../components/KitchenOrderCard.jsx'

import * as ApiCall from '../ApiCall.jsx';
import { Typography } from "@mui/material";


// loads a list of all the orders that the chef needs to make
// shows the chef the ingredients of the dish, extras the customer has requested
// and special instructions from the customer
// allows the chef to check off dishes that are complete
// in the case all dishes have completed the order will be moved to the complete tab
export default function KitchenOrders() {

  const [orders, setOrders] = React.useState([]);
  const [state, setState] = React.useState("loading");

  const NOTIFICATION_INTERVAL = 5000;

  function getOrders() {
    ApiCall.get("/order/remainingOrders")
      .then((recievedOrders) => {
    
        let orderList = []
        for (let i = 0; i < recievedOrders.length; i++) {
          //only add if the order isnt fully cooked
          if (recievedOrders[i].status < 2) {
            orderList.push(recievedOrders[i]);
          }        
        }

        //sort by oldest order
        orderList.sort((a, b) => {
          return (new Date(a.startTime) - new Date(b.startTime));
        });
        setOrders(orderList);
        if (orderList.length > 0) {
          setState("success");
        }
        else {
          setState("nothing");
        }

      })
      .catch((msg) => {alert("Failed to get remainng orders: " + msg)})
  }

  // to load the orders on first load of page
  React.useEffect(() => { 
    getOrders();
  }, []);


  // to load orders every interval after wards
  React.useEffect(() => {
    const interval = setInterval(() => {
      getOrders()
    }, NOTIFICATION_INTERVAL);

    return () => clearInterval(interval);
  }, []);


  if (state === "loading") {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center' }}>
        <CircularProgress />
      </Box>
    )
  }

  if (state === "nothing") {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center' }}>
        <Typography>Currently no orders for cooking</Typography>
      </Box>
    )
  }

  else if (state === "success") {
    return (
      <Container sx={{display: 'flex', flexDirection: 'column', alignItems: 'center' , gap: 1, pt: 2}}>
        {
          orders.map((order) => (
            <KitchenOrderCard key={order.id} orderInfo={order} ></KitchenOrderCard>
          ))
        }
      </Container>
    );
  }
  
  
};